var map = {
	"./fr": 664
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1614;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale ^\.\/(fr)$
// module id = 1614
// module chunks = 2